import { STORE_KEYS } from '@src/scripts/constants'

export function cachedToken(value) {
  if (arguments.length > 0) {
    sessionStorage.setItem(
      STORE_KEYS.TOKENS,
      (value && JSON.stringify(value)) || ''
    )
  } else {
    const item = sessionStorage.getItem(STORE_KEYS.TOKENS) || null
    value = (item && JSON.parse(item)) || null
  }

  return value
}

export function cachedOmnichannelUrl(token) {
  const item = token && sessionStorage.getItem(STORE_KEYS.OMNICHANNEL_URL)
  if (!item) return null

  try {
    const cache = JSON.parse(item)
    if (!cache?.url || cache.session !== sessionFingerprint(token)) {
      clearCachedOmnichannelUrl()
      return null
    }

    return cache
  } catch (error) {
    clearCachedOmnichannelUrl()
    return null
  }
}

export function cacheOmnichannelUrl(token, url, shortUrl) {
  if (!token || !url) return

  sessionStorage.setItem(
    STORE_KEYS.OMNICHANNEL_URL,
    JSON.stringify({
      session: sessionFingerprint(token),
      url,
      shortUrl: shortUrl || null
    })
  )
}

export function clearCachedOmnichannelUrl() {
  sessionStorage.removeItem(STORE_KEYS.OMNICHANNEL_URL)
}

// Binds the cached url to a single access token, so a link generated for an
// earlier session is never reused, without storing the token itself.
function sessionFingerprint(token) {
  let hash = 5381
  for (let index = 0; index < token.length; index++) {
    hash = (hash * 33) ^ token.charCodeAt(index)
  }

  return (hash >>> 0).toString(36)
}
